import { __assign, __read } from "tslib";
import React, { useEffect, useState } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { colors } from '@keen.io/colors';
import { createBarMotion } from '../../utils/animate.utils';
var transitionStyle = { transition: 'fill .2s ease-in' };
export var Bar = function (_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height, color = _a.color, colorOutOfRange = _a.colorOutOfRange, layout = _a.layout, groupMode = _a.groupMode, _b = _a.animate, animate = _b === void 0 ? true : _b, isActive = _a.isActive, dataSeriesOffset = _a.dataSeriesOffset;
    var _c = __read(useState(false), 2), initialDrawFinished = _c[0], setInitialDraw = _c[1];
    var barControls = useAnimation();
    var barVariants = __assign({}, createBarMotion({
        layout: layout,
        groupMode: groupMode,
        width: width,
        height: height,
        x: x,
        y: y,
        color: color,
        colorOutOfRange: colorOutOfRange,
    }));
    useEffect(function () {
        if (initialDrawFinished)
            barControls.start(barVariants.animate);
    }, [x, y, width, height]);
    useEffect(function () {
        if (initialDrawFinished)
            barControls.start(barVariants.defaultColor);
        setInitialDraw(true);
    }, [color]);
    useEffect(function () {
        barControls.start(barVariants.animate);
        if (isActive === null) {
            return;
        }
        if (isActive) {
            barControls.start(barVariants.active);
        }
        else {
            barControls.start(barVariants.inactive);
        }
    }, [isActive]);
    useEffect(function () {
        barControls.start(barVariants.offsetChange);
    }, [dataSeriesOffset]);
    var commonProps = {
        height: height,
        width: width,
        style: __assign(__assign({}, transitionStyle), { fill: color }),
    };
    return animate ? (React.createElement(motion.rect, __assign({ "data-testid": "bar" }, commonProps, barVariants, { animate: barControls, whileHover: colorOutOfRange && { fill: colors.gray[500] } }))) : (React.createElement("rect", __assign({}, commonProps, { x: x, y: y })));
};
export default Bar;
